export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref14085.921623f1.jpg";